import React, { FunctionComponent, useCallback, useState } from 'react';
import IActionButtonProps from '../IActionButtonProps';
import ContinueToCheckoutButton from '../../../presentational/actionButtons/customiseContinueToCheckout/ContinueToCheckoutButton';
import useCheckoutRedirectHandler from '../../../../hooks/useCheckoutRedirectHandler';

const ContinueToCheckoutContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { checkoutRedirectHandler, basketInitV3Data } = useCheckoutRedirectHandler(config);
  const buttonIsDisabled = !basketInitV3Data.vehicleId || config.disabled;

  const onClick = useCallback(async () => {
    await checkoutRedirectHandler(setIsSubmitting);
  }, [checkoutRedirectHandler]);

  if (config.checkoutUrl && config.isCheckout4Enabled) {
    return <ContinueToCheckoutButton onClick={onClick} disabled={buttonIsDisabled} loading={isSubmitting} isPrimary />;
  }

  return null;
};

export default ContinueToCheckoutContainer;
